var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-selector z-index-second"},_vm._l((_vm.titleArray),function(item,index){return _c('button',{key:index,staticClass:"item-selector-item",class:{ active: _vm.currentIndex == index },on:{"click":function($event){return _vm.onselectedClick(index)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }